import {Gen3UserService, Gen2UserService} from './services/UserService'
import {ENVIRONMENTS} from '#/notes/components/definitions'

const create = function (environment, auth) {
  switch (environment) {
    case ENVIRONMENTS.GEN_3:
      return new Gen3UserService(auth)
    case ENVIRONMENTS.GEN_2:
      return new Gen2UserService()
    default:
      return new Gen3UserService(auth)
  }
}

export default create
